<template>
  <tr>
    <th>{{ submission.userFirstName }} {{ submission.userLastName }}</th>
    <td>
      <a
        href="#"
        @click.prevent="viewVideo"
      ><span><Video />&nbsp;</span>{{ submission.name }}</a>
    </td>
    <td>
      <div
        v-if="submission.scores.length > 0"
      >
        <a
          href="#"
          @click.prevent="viewScores"
        >{{ submission.finalScore }}</a>
      </div>
      <div
        v-else
      >
        <span class="has-text-grey-light">N/A</span>
      </div>
    </td>
    <td>
      <span
        class="tooltip-hint"
        v-tooltip="formatDate(submission.submitDate, 'DD MMM YYYY  @ HH:mm')"
      >
        {{ formatDate(submission.submitDate, 'DD MMM YYYY') }}
      </span>
    </td>
    <td>
      <div class="dropdown is-hoverable is-right">
        <div class="dropdown-trigger">
          <button
            :aria-controls="`dropdown_${submission._id}`"
            class="button is-light"
            aria-haspopup="true"
          >
            <span>Actions</span>
            <span>&nbsp;<ChevronDown aria-hidden="true" /></span>
          </button>
        </div>
        <div
          :id="`dropdown_${submission._id}`"
          class="dropdown-menu"
          role="menu"
        >
          <div class="dropdown-content">
            <a
              href="#"
              class="dropdown-item has-text-danger"
              @click.prevent="deleteSubmission"
            >
              <span><Delete />&nbsp;Delete</span>
            </a>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import ChevronDown from 'vue-material-design-icons/ChevronDown.vue'
import Delete from 'vue-material-design-icons/Delete.vue'
import Video from 'vue-material-design-icons/Video.vue'
import datesMixin from '@/mixins/dates'

export default {
  name: 'SubmissionRow',
  mixins: [datesMixin],
  components: {
    ChevronDown,
    Video,
    Delete
  },
  props: {
    submission: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    viewVideo () {
      this.$emit('viewVideo', {
        fileName: this.submission.fileName,
        youtubeId: this.submission.youtubeId
      })
    },
    viewScores () {
      this.$emit('viewScores', this.submission.scores)
    },
    deleteSubmission () {
      this.$toasted.show('Are you sure you want to delete this submission?', {
        duration: null,
        action: [
          {
            text: 'Cancel',
            onClick: (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
          {
            text: 'Delete',
            onClick: (e, toastObject) => {
              toastObject.goAway(0)
              this.dispatchDelete()
            }
          }
        ]
      })
    },
    dispatchDelete () {
      this.$store
        .dispatch('submissions/DELETE_SUBMISSIONS', {
          userId: this.submission.userId,
          divisionId: this.submission._id
        })
        .then(() => {
          this.$toasted.success('Submission removed')
          this.$emit('reloadSubmission')
        })
        .catch(err => {
          this.$toasted.error('Error removing submission')
        })
    }
  }
}
</script>
